export default "__VITE_ASSET__CJUgGYpB__"